import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import { getOffsetDaysOfWeek } from 'helpers/intl-fns';

const messages = defineMessages({
  dowShort: {
    id: 'schedules.schedule-recurrence-days.dow-short',
    defaultMessage: '{dateTime, date, dow-short}',
  },
});

const ScheduleRecurrenceDays = ({ recurrence, startWeekOn = 'sun' }) => {
  const intl = useIntl();
  const daysOfWeek = getOffsetDaysOfWeek(startWeekOn);

  return daysOfWeek
    .filter(({ value }) => recurrence.days.includes(value))
    .map(({ dateTime }) => intl.formatMessage(messages.dowShort, { dateTime }))
    .join(', ');
};

ScheduleRecurrenceDays.propTypes = {
  recurring: PropTypes.bool,
  recurrence: PropTypes.shape({
    days: PropTypes.arrayOf(PropTypes.string),
  }),
  startWeekOn: PropTypes.string,
};

export default ScheduleRecurrenceDays;
